import { RouteLocationNormalized } from "vue-router";
import Storage from "@/core/services/storage";
let lockr = new Storage("cpms_");
import { CACHED_TABS_ROUTES } from "@/core/constant";
export type RouteItem = Partial<RouteLocationNormalized> & {
  fullPath: string;
  name: string;
  cachedFullPath: string;
};

export type ITabsViewState = {
  tabsList: RouteItem[]; // 标签页
};

export const state: ITabsViewState = {
  tabsList: lockr.get(CACHED_TABS_ROUTES) || [],
};
